import { OverlayTheme } from "@acin.reactjs/acin-ui/overlay";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";

const overlayTheme: ComponentCSSStyle<OverlayTheme> = {
  root: {
    zIndex: 99999,
  },
  variants: {
    draggable: {
      fade: {
        root: {
          zIndex: 99999,
        },
      },
    },
  },
};

export default overlayTheme;
